import React, { FunctionComponent } from 'react';
import { Presentation } from './presentation';
import { usePages } from '../../../hooks/usePages';
import type { CompanyPostsProps as Props } from './types';

const PAGINATE_PER = 10;

export const Component: FunctionComponent<Props> = (props) => {
  const {
    page,
    handlePageChange,
    shouldShowPagination,
    paginatedItems: paginatedPosts
  } = usePages(props.posts, PAGINATE_PER);

  return (
    <Presentation
      {...props}
      paginate_per={PAGINATE_PER}
      currentPage={page}
      shouldShowPagination={shouldShowPagination}
      paginatedPosts={paginatedPosts}
      onPageChange={handlePageChange}
    />
  );
};
